import { JobLocation } from '~Data';

export const jobLocationChoices: { [key in JobLocation]: string } = {
  [JobLocation.Remote]: 'Remote',
  [JobLocation.Statewide]: 'Statewide',
};
